﻿<template>
    <AuthPanel
        title="Sign in to Estimator Systems dashboard"
        footer-prompt="New to Estimator?"
        footer-label="Create account"
        footer-to="/register"
        :footer-disabled="isBusy">
        <UForm :schema="r$" :state="form" class="flex flex-col gap-6" @submit="submit">
            <BrFormField :variant="BrFormFieldVariants.Auth" label="Email" name="email">
                <UInput
                    v-model="form.email"
                    :placeholder="getPlaceholder(PlaceholderAction.Enter, PlaceholderEntity.Email)"
                    :variant="InputVariants.FrozenGlass"
                    autocomplete="username"
                    class="w-full" />
            </BrFormField>
            <BrFormField :variant="BrFormFieldVariants.Auth" label="Password" name="password">
                <template #hint>
                    <UButton
                        label="Forgot password?"
                        type="button"
                        :disabled="isBusy"
                        :variant="ButtonVariants.Link"
                        color="neutral"
                        class="mb-3 px-0! py-0! text-white/65 hover:not-disabled:text-white"
                        @click="navigateTo('/forgot-password')" />
                </template>
                <UInput
                    v-model="form.password"
                    :placeholder="getPlaceholder(PlaceholderAction.Enter, PlaceholderEntity.Password)"
                    :variant="InputVariants.FrozenGlass"
                    autocomplete="current-password"
                    class="w-full"
                    type="password" />
            </BrFormField>
            <UButton
                label="Sign In"
                :loading="isBusy"
                :variant="ButtonVariants.Glow"
                class="flex items-center justify-center gap-2"
                trailing
                type="submit" />
        </UForm>
    </AuthPanel>
</template>

<script lang="ts" setup>
    import { required, email } from '@regle/rules';

    import { PlaceholderAction, PlaceholderEntity, getPlaceholder } from '@constants/placeholders';
    import { ButtonVariants } from '@constants/button-variants';
    import { InputVariants } from '@constants/input-variants';
    import { HOME } from '@constants/routes';
    import { BrFormFieldVariants } from '@/assets/css/themes/custom-components/constants/br-form-field';

    definePageMeta({
        layout: 'default'
    });

    const route = useRoute();
    const auth = useAuth();

    const form = reactive({
        email: '',
        password: '',
        rememberMe: false
    });

    const rules = {
        email: { required, email },
        password: { required }
    };

    // needed for avoiding multiple requests for singing in. When completed request (not redirect) loading sets to false
    const redirecting = ref(false);
    const isBusy = computed(() => loading.value || redirecting.value);

    const getAfterLoginRedirect = () => route.query.redirect?.toString() || HOME;

    async function onSubmit() {
        await auth.signIn(form.email, form.password, form.rememberMe, getAfterLoginRedirect());

        redirecting.value = true;
    }

    const { r$, submit, loading } = useForm(form, rules, onSubmit);
</script>
